import { apiUrl, saveRecord } from './apiUtils';

const baseUrl = apiUrl + '/automate/steam/';

export function saveRequest(record: unknown): Promise<unknown> {
  return saveRecord(`${baseUrl}request-keys`, record);
}
